import { matchPath } from 'react-router-dom'

const providerRequestUrls = ['/secure/onboard/provider', '/secure/index/provider']

export function useProviderRequestPage(pagePath: string) {
  return providerRequestUrls.find((url) => {
    return matchPath({ path: `${url}/:id/request` }, pagePath)
  })
}
